import type { AppliedRule, PriceBreakdownLine, TieredBreakdownLine } from "./types";

export function generateBreakdown(
  basePrice: number,
  finalPrice: number,
  appliedRules: AppliedRule[],
  depositAmount: number | null,
  quantity: number,
  totalPerOrder?: number,
): PriceBreakdownLine[] {
  const lines: PriceBreakdownLine[] = [];

  const tieredRule = appliedRules.find((r) => r.tieredBreakdown && r.tieredBreakdown.length > 0);
  const resolvedTotal = totalPerOrder ?? finalPrice * quantity;

  if (tieredRule?.tieredBreakdown) {
    tieredRule.tieredBreakdown.forEach((tier: TieredBreakdownLine, idx: number) => {
      lines.push({
        label: idx === 0 ? `Base tier (×${tier.quantity})` : `Additional (×${tier.quantity})`,
        amount: tier.lineTotal,
        type: "tier",
      });
    });
  } else {
    lines.push({
      label: quantity > 1 ? `Base price (x${quantity})` : "Base price",
      amount: basePrice * quantity,
      type: "base",
    });
  }

  for (const rule of appliedRules) {
    if (rule.adjustment === 0) continue;
    if (rule.tieredBreakdown && rule.tieredBreakdown.length > 0) continue;

    const isDiscount = rule.adjustment < 0;
    const lineType = isDiscount ? "discount" : rule.ruleType === "PEAK_TIME" ? "surcharge" : "override";

    lines.push({
      label: rule.ruleName,
      amount: rule.adjustment * quantity,
      type: lineType as PriceBreakdownLine["type"],
    });
  }

  lines.push({
    label: "Total",
    amount: resolvedTotal,
    type: "total",
  });

  if (depositAmount !== null) {
    lines.push({
      label: "Deposit (pay now)",
      amount: depositAmount * quantity,
      type: "deposit",
    });
    lines.push({
      label: "Remainder (pay later)",
      amount: (finalPrice - depositAmount) * quantity,
      type: "deposit",
    });
  }

  return lines;
}
